import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Overlay, Popover } from "react-bootstrap";
import { saveUserEventFavourite } from "../../../../../Actions/ListManagerCalendarActions";
import { set } from "lodash";
const HOVER_HIDE_DELAY_MS = 0;
const HOVER_SHOW_DELAY_MS = 0;

const CalendarCell = ({ event, date, saveUserEventFavourite }) => {
  const [eventSelected, setEventSelected] = useState(Boolean(event.is_starred));
  const [show, setShow] = useState(false);
  const [arrowLeft, setArrowLeft] = useState("45%");
  const targetRef = useRef(null);
  const popoverNodeRef = useRef(null);
  const hideTimeoutRef = useRef(null);
  const showTimeoutRef = useRef(null);
  const [placement, setPlacement] = useState("bottom");

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const eventDate = new Date(date);
  const isPast = eventDate < today;
  const eventClass = isPast ? "calendar-event past" : "calendar-event future";
  const isPanarayEvent = event.event_type === 2;
  const handleEventSelected = (e) => {
    e.stopPropagation();
    saveUserEventFavourite(event.osid, !eventSelected, event.event_name, event.event_type, date);
    setEventSelected((prev) => !prev);
  };
  useEffect(() => {
    const scrollContainer = document.getElementById("futureListCustomScroll");
    const verticalScrollContainer = document.getElementById("calendarCustomScroll");
    const handleScroll = () => setShow(false);
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
    }
    if (verticalScrollContainer) {
      verticalScrollContainer.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
      if (verticalScrollContainer) {
        verticalScrollContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  useEffect(() => {
    if (!isPanarayEvent) return;

    const onDocMouseMove = (e) => {
      const overTarget = targetRef.current && targetRef.current.contains(e.target);
      const overPopover = popoverNodeRef.current && popoverNodeRef.current.contains(e.target);

      if (overTarget || overPopover) {
        if (hideTimeoutRef.current) {
          clearTimeout(hideTimeoutRef.current);
          hideTimeoutRef.current = null;
        }
        if (!show && !showTimeoutRef.current) {
          showTimeoutRef.current = setTimeout(() => {
            setShow(true);
            showTimeoutRef.current = null;
          }, HOVER_SHOW_DELAY_MS);
        }
        return;
      }
      if (showTimeoutRef.current) {
        clearTimeout(showTimeoutRef.current);
        showTimeoutRef.current = null;
      }
      if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
      hideTimeoutRef.current = setTimeout(() => {
        setShow(false);
        hideTimeoutRef.current = null;
      }, HOVER_HIDE_DELAY_MS);
    };

    document.addEventListener("mousemove", onDocMouseMove);
    return () => {
      document.removeEventListener("mousemove", onDocMouseMove);
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
        hideTimeoutRef.current = null;
      }
      if (showTimeoutRef.current) {
        clearTimeout(showTimeoutRef.current);
        showTimeoutRef.current = null;
      }
    };
  }, [isPanarayEvent, show]);
  const handleClickTrigger = (e) => {
    if (isPanarayEvent) return;
    const rect = e.target.getBoundingClientRect();
    const topViewport = rect.top;
    if (window.innerWidth - rect.left <= 105) {
      setArrowLeft(`${200 - (window.innerWidth - rect.left)}px`);
    } else {
      setArrowLeft("45%");
    }
    setPlacement(window.innerHeight - topViewport < 280 ? "top" : "bottom");
    setShow((prev) => !prev);
  };

  const renderTooltip = (
    <Popover
      id={`popover-${event.event_date}-${event.symbol}`}
      className="future-event-popover"
      style={{
        maxWidth: isPanarayEvent? "85px" : "200px",
        fontSize: "12px",
        border: "1px solid #00A3FF",
        textAlign: "center",
        pointerEvents: "auto",
        minWidth: "85px",
        '--popover-arrow-left': arrowLeft,
      }}
    >
      <div
        ref={popoverNodeRef}
        style={{
          position: "relative",
          boxSizing: "border-box",
          padding: "4px",
        }}
      >
        { !event.potentialCatalyst &&
          <div
            onClick={handleEventSelected}
            onMouseDown={(e) => e.stopPropagation()} // prevent overlay rootClose from treating this as outside click
            style={{
              position: "absolute",
              right: 3,
              cursor: "pointer",
              fontSize: "16px",
              color: eventSelected ? "#00A3FF" : "#ccc",
              userSelect: "none",
              zIndex: 3,
            }}
            title={eventSelected ? "Unstar" : "Star"}
          >
            ★
          </div>
        }

        <div style={{ fontWeight: "bold", marginBottom: isPanarayEvent ? '2px' : "6px", marginTop: isPanarayEvent ? '3px' : '0px', maxWidth: '170px', marginLeft: '5px' }}>{event.event_name}</div>

        {event.event_note ? (
          <div style={{ fontSize: "12px", color: "#333", whiteSpace: "normal" }}>{event.event_note}</div>
        ) : null}
      </div>
    </Popover>
  );

  return (
    <>
      <div
        ref={targetRef}
        className={eventClass}
        style={{
          cursor: "pointer",
          position: "absolute",
          left: `${event.xPos}px`,
          top: `${event.yPos}px`,
          width: `${event.width}px`,
        }}
        onClick={handleClickTrigger}
        onMouseEnter={() => isPanarayEvent && setShow(true)}
      >
        <div style={{ position: "relative" }}>
          <span className="calendar-event-symbol">{event.symbol}</span>
          <span
            style={{
              position: "absolute",
              right: "-4px",
              fontSize: "18px",
              color: event.potentialCatalyst ? "#000000" : "#00A3FF",
              top: "-4px",
            }}
          >
            {event.potentialCatalyst ? "☆" : (eventSelected ? "★" : "")}
          </span>
        </div>
      </div>

      <Overlay
        target={targetRef.current}
        show={show}
        placement={placement}
        rootClose={!isPanarayEvent}
        onHide={() => setShow(false)}
      >
        {renderTooltip}
      </Overlay>
    </>
  );
};

const mapDispatchToProps = (dispatch)=>({
  saveUserEventFavourite: (osid, is_starred, event_name, event_type, event_date) => dispatch(saveUserEventFavourite( osid, is_starred, event_name, event_type, event_date ))
})
export default connect(null, mapDispatchToProps)(CalendarCell);
